const featuredContentConstantsAr = {
  featuredContentPageBreadcrumb: 'المحتوى المعروض',
  featuredContentPageTitle: 'المحتوى المعروض',
  manageFeaturedContentBreadcrumb: 'إدارة المحتوى',
  manageFeaturedContentPageTitle: 'ادارة المحتوى',
  updateFeaturedContentButton: ' تحديث المحتوى المعروض',
  addFeaturedContentDialogTitle: 'إضافة قائمة التشغيل',
  choosePlaylistLabel: 'إختر فائمة التشغيل',
  editFeaturedContentDialogTitle: 'تحرير قائمة التشغيل',
  editFeaturedContentDialogButton: 'حفظ التعديلات',
  addFeaturedContentDialogButton: 'إضافة قائمة تشغيل جديدة',
  emptyPlaylistNameErrorMessage: 'الرجاء إضافة اسم قائمة التشغيل',
  manageFeaturedDeleteButton: 'حذف',
  errorSnackbar: '! حدث خطأ ما',
  successSnackbar: '! تم الحفظ بنجاح',
  landingPageTitle: 'الصفحه الرئيسية - الزوار',
  homePageTitle: 'الصفحه الرئيسية - المسجلين',
  latestVideoPage: 'صفحة أحدث المواد',
  contentIdeasPage: ' صفحة أفكار لمشروعك',
  latestVideoPlaylistNameColumn: 'اسم قائمة التشغيل',
  latestVideoPlaylistIdColumn: 'معرف قائمة التشغيل',
};

export default featuredContentConstantsAr;
